<template>
  <div
    ref="thumbnail"
    class="crop-image"
    v-lazy:background-image="src"
    :key="src"
  >
    <div class="video-icon" v-show="isVideo"></div>
    <div class="mul-icon" v-show="mul"></div>
  </div>
</template>

<script>
import { exportImage } from "../../../service/media";

export default {
  name: "CropImgComponent",
  props: {
    model: {
      type: Object,
      default: () => {},
    },
    mul: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      src: "",
    };
  },
  computed: {
    /**
     * 是否为视频
     */
    isVideo() {
      return this.model.type === 2;
    },
  },
  async mounted() {
    // 裁切图片
    const blob = await exportImage({ model: this.model });
    const file = new FileReader();
    file.readAsDataURL(blob);
    file.onload = (e) => {
      this.src = e.target.result;
    };
  },
};
</script>

<style lang="less" scoped>
.crop-image {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .video-icon {
    width: 65%;
    padding-bottom: 65%;
    z-index: 2;
    background-size: cover;
    background-image: url("../../../../public/images/schedule_posts/list/video.png");
  }
  .mul-icon {
    background-image: url("../../../../public/images/library/album@3x.png");
    width: 10px;
    height: 10px;
    background-size: contain;
    background-position: center;
    position: absolute;
    right: 2px;
    top: 2px;
  }
}
</style>
